import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'svm-security',
  template: ` <lib-login></lib-login> `,
  styles: [],
})
export class SecurityComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
